import script from "./coder-prompter.vue?vue&type=script&setup=true&lang=js"
export * from "./coder-prompter.vue?vue&type=script&setup=true&lang=js"

import "./coder-prompter.vue?vue&type=style&index=0&id=7cb9ad2e&lang=scss"

const __exports__ = script;

export default __exports__